import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Progress, Spin } from "antd";
import "./PreAssessment.styles.scss";
import {
  fetchPreassessmentQuestions,
  submitPreassessments,
} from "../../../slices/Admin/preAssessments.slice";
import ErrorAlert from "../../../components/UI/ErrorAlert/ErrorAlert";
import NavigationButtons from "./NavigationButtons";
import QuestionList from "./QuestionList";

const PreAssessment = ({ handleNext, setSubmissionIdCallback }) => {
  const [step, setStep] = useState(1);
  const dispatch = useDispatch();
  const [formFields, setFormFields] = useState([]);
  const [form] = Form.useForm();
  const [submissionId, setSubmissionId] = useState("");
  const [fieldError, setFieldError] = useState([]);

  const { sections, questionData, preassementError } = useSelector(
    (state) => state.preAssessment
  );

  useEffect(() => {
    sections.length > 0 &&
      dispatch(fetchPreassessmentQuestions(sections[step - 1]));
  }, [sections, step]);

  useEffect(() => {
    setSubmissionId(questionData?.id);
    setSubmissionIdCallback && setSubmissionIdCallback(questionData?.id);
  }, [questionData]);

  const IsFormEdit = // check if the form is already answered
    questionData?.section?.questions &&
    questionData?.section?.questions.some(
      (qn) => qn.answer || (qn.answers && qn.answers.length > 0)
    );

  const handleTraverse = (index) => {
    form.resetFields();
    setFieldError([]);
    setFormFields([]);
    setStep(step + index);
  };

  const gotoNextSection = () =>
    // check if a next form page exists
    step < sections.length ? handleTraverse(1) : handleNext();

  const onSubmitSuccess = () => {
    if (formFields.length > 0) {
      dispatch(
        submitPreassessments(
          {
            answers: formFields,
            assessment_submission_id: submissionId,
            section_id: sections[step - 1],
          },
          IsFormEdit,
          () => {
            setFormFields([]);
            gotoNextSection();
          }
        )
      );
    } else gotoNextSection();
  };

  const onFinishFailed = (value) => {
    const errorFields = value.errorFields.map((error) => error.name);
    setFieldError(errorFields.flat());
  };

  return (
    <div className="pre-assessment-wrapper">
      <ErrorAlert
        errorData={preassementError}
        message={preassementError && "Wrong Input"}
        style={{ margin: "0px" }}
      />
      <Progress
        steps={sections.length}
        percent={(step / sections.length) * 100}
        showInfo={false}
        className="assessment-progress"
        strokeColor="#0058be"
        size="small"
      />

      <Form
        layout="vertical"
        form={form}
        onFinish={onSubmitSuccess}
        autoComplete="off"
        validateTrigger="onBlur"
        scrollToFirstError
        onFinishFailed={onFinishFailed}
      >
        <>
          <div className="pre-assessment-step-name">
            {questionData?.section?.name}
          </div>
          <QuestionList
            fieldError={fieldError}
            formFields={formFields}
            setFormFields={setFormFields}
            setFieldError={setFieldError}
            form={form}
          />
          <NavigationButtons
            step={step}
            sections={sections}
            handleTraverse={handleTraverse}
          />
        </>
      </Form>
    </div>
  );
};

export default PreAssessment;
